import React from 'react';

type Props = {
    name: string
    stat: string | number | undefined
}

function StatBoxSimple(props: Props) {
    return (
      <div>
          <dt className="truncate text-sm font-medium text-gray-500">{props.name}</dt>
          <dd className="mt-1 text-2xl font-semibold tracking-tight text-gray-900">{props.stat}</dd>
      </div>
    );
}

export default StatBoxSimple;